export default __webpack_public_path__ + "static/media/tituloSobre.4e4d827b.png";